// extracted by mini-css-extract-plugin
export default {"container":"Notepad_container__q63h3","button":"Notepad_button__XSfWk"};